import { ref } from 'vue'

export const MessageCharLimit = 8000

export const discussionTriggerChannel = ref(null)
export const discussionListenChannel = ref(null)
